import { Container, createStyles, Group } from '@mantine/core';
import { Text } from '@repo/foundations';
import { observer } from 'mobx-react-lite';
import { ActivityLogPerformerIcon } from '../../../components/ActivityLogPerformer/ActivityLogPerformerIcon';
import type { IActivityLogPerformer } from '../../../components/ActivityLogPerformer/types';
import { ViewportWrapper } from './ViewportWrapper';

const useStyles = createStyles((theme) => ({
	container: {
		paddingLeft: theme.spacing.md,
		paddingRight: theme.spacing.md,
		alignItems: 'center',
		gap: theme.spacing.sm,
		flexWrap: 'nowrap',
	},
	textContainer: {
		padding: 0,
	},
	text: {
		paddingInlineEnd: theme.spacing['3xs'],
	},
}));

export const ActivityLogBody = observer(
	({
		children,
		performer,
	}: {
		children: React.ReactNode;
		performer: IActivityLogPerformer;
	}) => {
		const { classes } = useStyles();

		return (
			<ViewportWrapper>
				<Group className={classes.container}>
					<ActivityLogPerformerIcon performer={performer} />
					<Group spacing="xs" position="apart">
						<Container className={classes.textContainer}>
							<Text size="sm" weight="bold" span className={classes.text}>
								{performer.metadata.display_name ??
									performer.metadata.name ??
									'Unknown'}
							</Text>
							{children}
						</Container>
					</Group>
				</Group>
			</ViewportWrapper>
		);
	}
);
